<template>
  <div class="business-consult">
    <div class="con-search">
      <van-field v-model="value" placeholder="搜索关键字" />
      <div class="s-icon" @click="onSearch()">
        <img src="@/assets/publicImg/search.png" alt />
      </div>
    </div>

    <div class="con-div">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <van-card v-for="(item,index) in dataList" :key="index" @click.prevent="onCheck(item)">
            <template #title>
              <div class="card-title">{{changeData(item.dataType)}}</div>
            </template>
            <template #desc>
              <div class="card-desc1">{{item.content}}</div>
              <div class="card-desc2">咨询时间：{{item.createTime}}</div>
            </template>
            <template #footer>
              <van-tag color="#D4D4D4" text-color="#fff" v-if="item.replyStatus==0">待回复</van-tag>
              <van-tag color="#FFCCB4" text-color="#fff" v-if="item.replyStatus==1">已回复</van-tag>
            </template>
            <template #bottom>
              <div>></div>
            </template>
          </van-card>
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="con-but" @click="addConsult">
      <img src="./img/but.png" alt />
    </div>
  </div>
</template>

<script>
import URLTB from "@/api/apiTB";
import { Toast } from 'vant';
export default {
  data() {
    return {
      value: '',
      dataList: [],
      page: 1,
      size: 10,
      loading: false,
      finished: false,
      refreshing: false,
    }
  },
  mounted() {

  },
  methods: {
    onLoad() {
      this.getData()
    },
    onRefresh() {
      // 清空列表数据
      this.page = 1
      this.dataList = []
      this.finished = false;
      this.loading = true;
      this.getData()
    },
    getData() {
      let that = this
      let data = {
        param: that.value,
        userId: localStorage.getItem('userid'),
        type: 'consult',
        from: 'front',
        page: that.page,
        size: that.size
      }
      that.$fetchGet(URLTB.communication.url, data).then(res => {
        if (res.data.code == 20000) {
          that.refreshing = false
          that.loading = false
          let list = res.data.data.records
          let total = res.data.data.total
          if (list == null || list.length <= 0) {
            //加载完成
            that.finished = true
            return
          }
          if (that.page > 1) {
            that.dataList = [...that.dataList, ...list]
          } else {
            that.dataList = list
          }
          if (that.page * that.size >= total) {
            that.finished = true
            return
          }
          if (that.page * that.size < total) {
            that.page++
          }
        }
      })
    },
    //搜索
    onSearch() {
      this.dataList = []
      this.getData()
    },
    // 改变数据状态
    changeData(i) {
      let dataType = null
      switch (i) {
        case 3:
          dataType = '贷款业务'
          break;
        case 4:
          dataType = '保险业务'
          break;
        case 5:
          dataType = '操作使用'
          break;
        case 6:
          dataType = '其他'
          break;
        default:
          break;
      }
      return dataType
    },
    addConsult() {//我要咨询
      this.$router.push('/addConsult')
    },
    onCheck(item) {//详情
      this.$router.push({ path: '/consultDetails', query: { id: item.id } })
    }
  }
}
</script>

<style lang="less" scoped>
.business-consult {
  height: 100vh;
  background-color: #ffffff;
  font-family: Source Han Sans CN;
  overflow: scroll;
  .con-search {
    width: 355px;
    height: 30px;
    margin: 7px auto 8px auto;
    background: url("../../assets/publicImg/search-bg.png") no-repeat 100%;
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .van-cell {
      width: 300px;
      height: 30px;
      line-height: 30px;
      padding: 0 0 0 13px;
      background: transparent;
    }
    .s-icon {
      width: 40px;
      height: 30px;
      line-height: 27px;
      img {
        width: 14px;
        height: 14px;
        margin-left: 13px;
      }
    }
  }
  .con-div {
    height: calc(100vh - 130px);
    margin-top: 23px;
    overflow: scroll;
    .van-card {
      width: 355px;
      height: 75px;
      // margin: 10px auto auto;
      // padding: 12px;
      font-weight: 400;
      background-color: #fff;
      border-radius: 5px;
      color: #666666;
      .van-card__content {
        min-height: auto;
      }
      .van-card__footer {
        position: absolute;
        top: 0;
        right: 2px;
      }
      .van-card__bottom {
        position: absolute;
        top: 20px;
        right: 0;
        div {
          width: 5px;
          height: 7px;
          color: #d4d4d4;
        }
      }
      .card-title {
        font-weight: 500px;
        font-size: 14px;
      }
      .card-desc1 {
        width: 253px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        padding: 5px 0;
        font-size: 11px;
      }
      .card-desc2 {
        font-size: 10px;
        color: #999999;
      }
    }
  }
  .con-but {
    width: 130px;
    height: 40px;
    margin-left: 210px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>